module.exports = __webpack_public_path__ + "abranch_2.png?d0c71e083e8fc82230ba4232e997ba03";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/abranch_2.png
// module id = 78
// module chunks = 0